import React, {memo, useMemo} from 'react';
import {isEqual} from 'lodash';
import styled from 'styled-components';
import DocumentName from '../../DocumentName/DocumentName';
import SignOffs from '../../SignOffs/SignOffs';
import Button from '../../BaseComponentWrappers/MotifButton';
import {labels} from '../../../../util/utils';
import {useUserPreferences} from '../../../../util/customHooks';
import Utility from '../../../../util/utilityfunctions';
import utility from '../../../../util/utilityfunctions';

function EvidenceItem({document, engagementId, documentsSignOff = new Map(), onDocumentSignOffChange}) {
	const signOff = useMemo(() => {
		if (documentsSignOff.has(document.id)) {
			return documentsSignOff.get(document.id);
		}

		return 3;
	}, [documentsSignOff]);

	const userPreferences = useUserPreferences();
	const isPaperProfile = utility.isPaperProfile(document.documentTypeId);

	const documentSignOffs = useMemo(() => {
		return Utility.formatGetAllDocumentsApprovalsForSignOffsControl(document.approvals, userPreferences);
	}, [userPreferences, document]);

	return (
		<StyledEvidenceItem className="StyledEvidenceItem">
			<section className="evidenceItemWrapper">
				<section className="document-name">
					<DocumentName
						key={document.id}
						openGuidedWorkflowDocument={null}
						documentName={document.documentName}
						documentTypeId={document.documentTypeId}
						documentTypeName={document.documentTypeName}
						fileExt={document.fileExt}
						documentId={document.id}
						engagementId={document.engagementId}
						size="medium"
						hasComments={document.hasComments}
						hasHiddenSheets={document.hasHiddenSheets}
						hasHighlights={document.hasHighlights}
						isConflicted={document.isConflicted}
						trackChange={document.trackChange}
						isReturned={document.isReturned}
						isReadOnly={document.isReadOnly}
						showShared
						isShared={document.isShared}
					/>
				</section>
				<section className="sign-off">
					<SignOffs
						fromHandoff
						docTypeId={document.documentTypeId}
						documentId={document.id}
						document={document}
						engagementId={engagementId}
						isDisabled
						documentSignOffs={documentSignOffs}
						userDateFormat={userPreferences.dateFormat}
					/>
				</section>
			</section>
			<section className="signoff-button" key={signOff}>
				<Button
					name={labels.preparer}
					variant={signOff === 1 ? 'primary' : 'secondary'}
					onClick={() => onDocumentSignOffChange(document.id, 1)}
					showLabel
					isEllipsed
					buttonLabel={labels.preparer}
					noOfLines={1}
					disabled={isPaperProfile}
				/>
				<Button
					name={labels.reviewer}
					variant={signOff === 2 ? 'primary' : 'secondary'}
					onClick={() => onDocumentSignOffChange(document.id, 2)}
					showLabel
					isEllipsed
					buttonLabel={labels.reviewer}
					noOfLines={1}
					disabled={isPaperProfile}
				/>
				<Button
					name={labels.none}
					variant={signOff === 3 ? 'primary' : 'secondary'}
					onClick={() => onDocumentSignOffChange(document.id, 3)}
					showLabel
					isEllipsed
					buttonLabel={labels.none}
					noOfLines={1}
					disabled={isPaperProfile}
				/>
			</section>
		</StyledEvidenceItem>
	);
}

export default memo(EvidenceItem, isEqual);

const StyledEvidenceItem = styled.section`
	display: flex;
	width: 100%;
	border-bottom: var(--px-1) solid var(--neutrals-200);
	.evidenceItemWrapper {
		display: flex;
		width: calc(100% - var(--px-600));
	}

	.document-name {
		display: flex;
		width: calc(100% - var(--px-210));
		margin-top: var(--px-10);
		margin-bottom: var(--px-10);

		.DocumentNameContainer {
			.DocumentNameDetails {
				width: calc(100% - var(--px-30)) !important;
				.DocumentName {
					font-size: var(--px-12);
				}
			}
			&.name-link {
				&:hover,
				&:focus {
					text-decoration: none !important;
				}
			}
		}
	}

	.sign-off {
		display: flex;
		width: var(--px-210);
		margin-top: var(--px-10);
		border-right: var(--px-1) solid var(--neutrals-200);
		.evidenceSignOff {
			margin-top: var(--px-10);
		}
	}

	.signoff-button {
		display: flex;
		width: var(--px-600);
		padding-left: var(--px-20);
		padding-right: var(--px-20);
		align-items: center;
		justify-content: flex-end;

		.motif-button {
			width: var(--px-130);
			height: var(--px-32);
			.ellipses {
				justify-content: center;
			}
		}
	}
`;
